import API_BASE from "../config";
import authHeader from "./auth-header";
import axios from "axios";

const API_URL = API_BASE + "/api/upload";

// Uploads a single image file (field name "image"). Returns { url, image_url, filename }.
const uploadImage = (file, onProgress) => {
  const formData = new FormData();
  formData.append("image", file);

  return axios.post(API_URL, formData, {
    headers: {
      ...authHeader(),
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: (e) => {
      if (onProgress && e.total) {
        onProgress(Math.round((e.loaded * 100) / e.total));
      }
    },
  });
};

// Lists all uploaded images with product-assignment status.
const list = () =>
  axios.get(`${API_URL}/list`, { headers: authHeader() });

// Deletes an unassigned uploaded image by filename.
const remove = (filename) =>
  axios.delete(`${API_URL}/${encodeURIComponent(filename)}`, {
    headers: authHeader(),
  });

const UploadService = { uploadImage, list, remove };

export default UploadService;
